import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "projects/shared/environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class countriesService {
  http = inject(HttpClient)
  countries: ILangs[] = [
    { "name": "Afghanistan", "language": "Pashto", "languageCode": "ps", "currency": "AFN", "currencyName": "Afghan Afghani", "code": "AF" },
    { "name": "Albania", "language": "Albanian", "languageCode": "sq", "currency": "ALL", "currencyName": "Albanian Lek", "code": "AL" },
    { "name": "Algeria", "language": "Arabic", "languageCode": "ar", "currency": "DZD", "currencyName": "Algerian Dinar", "code": "DZ" },
    { "name": "Andorra", "language": "Catalan", "languageCode": "ca", "currency": "EUR", "currencyName": "Euro", "code": "AD" },
    { "name": "Angola", "language": "Portuguese", "languageCode": "pt", "currency": "AOA", "currencyName": "Angolan Kwanza", "code": "AO" },
    { "name": "Antigua and Barbuda", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "AG" },
    { "name": "Argentina", "language": "Spanish", "languageCode": "es", "currency": "ARS", "currencyName": "Argentine Peso", "code": "AR" },
    { "name": "Armenia", "language": "Armenian", "languageCode": "hy", "currency": "AMD", "currencyName": "Armenian Dram", "code": "AM" },
    { "name": "Australia", "language": "English", "languageCode": "en", "currency": "AUD", "currencyName": "Australian Dollar", "code": "AU" },
    { "name": "Austria", "language": "German", "languageCode": "de", "currency": "EUR", "currencyName": "Euro", "code": "AT" },
    { "name": "Azerbaijan", "language": "Azerbaijani", "languageCode": "az", "currency": "AZN", "currencyName": "Azerbaijani Manat", "code": "AZ" },
    { "name": "Bahamas", "language": "English", "languageCode": "en", "currency": "BSD", "currencyName": "Bahamian Dollar", "code": "BS" },
    { "name": "Bahrain", "language": "Arabic", "languageCode": "ar", "currency": "BHD", "currencyName": "Bahraini Dinar", "code": "BH" },
    { "name": "Bangladesh", "language": "Bengali", "languageCode": "bn", "currency": "BDT", "currencyName": "Bangladeshi Taka", "code": "BD" },
    { "name": "Barbados", "language": "English", "languageCode": "en", "currency": "BBD", "currencyName": "Barbadian Dollar", "code": "BB" },
    { "name": "Belarus", "language": "Belarusian", "languageCode": "be", "currency": "BYN", "currencyName": "Belarusian Ruble", "code": "BY" },
    { "name": "Belgium", "language": "Dutch", "languageCode": "nl", "currency": "EUR", "currencyName": "Euro", "code": "BE" },
    { "name": "Belize", "language": "English", "languageCode": "en", "currency": "BZD", "currencyName": "Belize Dollar", "code": "BZ" },
    { "name": "Benin", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "BJ" },
    { "name": "Bhutan", "language": "Dzongkha", "languageCode": "dz", "currency": "BTN", "currencyName": "Bhutanese Ngultrum", "code": "BT" },
    { "name": "Bolivia", "language": "Spanish", "languageCode": "es", "currency": "BOB", "currencyName": "Bolivian Boliviano", "code": "BO" },
    { "name": "Bosnia and Herzegovina", "language": "Bosnian", "languageCode": "bs", "currency": "BAM", "currencyName": "Bosnia-Herzegovina Convertible Mark", "code": "BA" },
    { "name": "Botswana", "language": "English", "languageCode": "en", "currency": "BWP", "currencyName": "Botswana Pula", "code": "BW" },
    { "name": "Brazil", "language": "Portuguese", "languageCode": "pt", "currency": "BRL", "currencyName": "Brazilian Real", "code": "BR" },
    { "name": "Brunei", "language": "Malay", "languageCode": "ms", "currency": "BND", "currencyName": "Brunei Dollar", "code": "BN" },
    { "name": "Bulgaria", "language": "Bulgarian", "languageCode": "bg", "currency": "BGN", "currencyName": "Bulgarian Lev", "code": "BG" },
    { "name": "Burkina Faso", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "BF" },
    { "name": "Burundi", "language": "French", "languageCode": "fr", "currency": "BIF", "currencyName": "Burundian Franc", "code": "BI" },
    { "name": "Cabo Verde", "language": "Portuguese", "languageCode": "pt", "currency": "CVE", "currencyName": "Cape Verdean Escudo", "code": "CV" },
    { "name": "Cambodia", "language": "Khmer", "languageCode": "km", "currency": "KHR", "currencyName": "Cambodian Riel", "code": "KH" },
    { "name": "Cameroon", "language": "French", "languageCode": "fr", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "CM" },
    { "name": "Canada", "language": "English", "languageCode": "en", "currency": "CAD", "currencyName": "Canadian Dollar", "code": "CA" },
    { "name": "Central African Republic", "language": "French", "languageCode": "fr", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "CF" },
    { "name": "Chad", "language": "French", "languageCode": "fr", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "TD" },
    { "name": "Chile", "language": "Spanish", "languageCode": "es", "currency": "CLP", "currencyName": "Chilean Peso", "code": "CL" },
    { "name": "China", "language": "Mandarin", "languageCode": "zh", "currency": "CNY", "currencyName": "Chinese Yuan", "code": "CN" },
    { "name": "Colombia", "language": "Spanish", "languageCode": "es", "currency": "COP", "currencyName": "Colombian Peso", "code": "CO" },
    { "name": "Comoros", "language": "Arabic", "languageCode": "ar", "currency": "KMF", "currencyName": "Comorian Franc", "code": "KM" },
    { "name": "Congo (Congo-Brazzaville)", "language": "French", "languageCode": "fr", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "CG" },
    { "name": "Costa Rica", "language": "Spanish", "languageCode": "es", "currency": "CRC", "currencyName": "Costa Rican Colón", "code": "CR" },
    { "name": "Croatia", "language": "Croatian", "languageCode": "hr", "currency": "HRK", "currencyName": "Croatian Kuna", "code": "HR" },
    { "name": "Cuba", "language": "Spanish", "languageCode": "es", "currency": "CUP", "currencyName": "Cuban Peso", "code": "CU" },
    { "name": "Cyprus", "language": "Greek", "languageCode": "el", "currency": "EUR", "currencyName": "Euro", "code": "CY" },
    { "name": "Czechia (Czech Republic)", "language": "Czech", "languageCode": "cs", "currency": "CZK", "currencyName": "Czech Koruna", "code": "CZ" },
    { "name": "Denmark", "language": "Danish", "languageCode": "da", "currency": "DKK", "currencyName": "Danish Krone", "code": "DK" },
    { "name": "Djibouti", "language": "Arabic", "languageCode": "ar", "currency": "DJF", "currencyName": "Djiboutian Franc", "code": "DJ" },
    { "name": "Dominica", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "DM" },
    { "name": "Dominican Republic", "language": "Spanish", "languageCode": "es", "currency": "DOP", "currencyName": "Dominican Peso", "code": "DO" },
    { "name": "Ecuador", "language": "Spanish", "languageCode": "es", "currency": "USD", "currencyName": "United States Dollar", "code": "EC" },
    { "name": "Egypt", "language": "Arabic", "languageCode": "ar", "currency": "EGP", "currencyName": "Egyptian Pound", "code": "EG" },
    { "name": "El Salvador", "language": "Spanish", "languageCode": "es", "currency": "USD", "currencyName": "United States Dollar", "code": "SV" },
    { "name": "Equatorial Guinea", "language": "Spanish", "languageCode": "es", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "GQ" },
    { "name": "Eritrea", "language": "Tigrinya", "languageCode": "ti", "currency": "ERN", "currencyName": "Eritrean Nakfa", "code": "ER" },
    { "name": "Estonia", "language": "Estonian", "languageCode": "et", "currency": "EUR", "currencyName": "Euro", "code": "EE" },
    { "name": "Eswatini (fmr. Swaziland)", "language": "Swazi", "languageCode": "ss", "currency": "SZL", "currencyName": "Swazi Lilangeni", "code": "SZ" },
    { "name": "Ethiopia", "language": "Amharic", "languageCode": "am", "currency": "ETB", "currencyName": "Ethiopian Birr", "code": "ET" },
    { "name": "Fiji", "language": "English", "languageCode": "en", "currency": "FJD", "currencyName": "Fijian Dollar", "code": "FJ" },
    { "name": "Finland", "language": "Finnish", "languageCode": "fi", "currency": "EUR", "currencyName": "Euro", "code": "FI" },
    { "name": "France", "language": "French", "languageCode": "fr", "currency": "EUR", "currencyName": "Euro", "code": "FR" },
    { "name": "Gabon", "language": "French", "languageCode": "fr", "currency": "XAF", "currencyName": "Central African CFA Franc", "code": "GA" },
    { "name": "Gambia", "language": "English", "languageCode": "en", "currency": "GMD", "currencyName": "Gambian Dalasi", "code": "GM" },
    { "name": "Georgia", "language": "Georgian", "languageCode": "ka", "currency": "GEL", "currencyName": "Georgian Lari", "code": "GE" },
    { "name": "Germany", "language": "German", "languageCode": "de", "currency": "EUR", "currencyName": "Euro", "code": "DE" },
    { "name": "Ghana", "language": "English", "languageCode": "en", "currency": "GHS", "currencyName": "Ghanaian Cedi", "code": "GH" },
    { "name": "Greece", "language": "Greek", "languageCode": "el", "currency": "EUR", "currencyName": "Euro", "code": "GR" },
    { "name": "Grenada", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "GD" },
    { "name": "Guatemala", "language": "Spanish", "languageCode": "es", "currency": "GTQ", "currencyName": "Guatemalan Quetzal", "code": "GT" },
    { "name": "Guinea", "language": "French", "languageCode": "fr", "currency": "GNF", "currencyName": "Guinean Franc", "code": "GN" },
    { "name": "Guinea-Bissau", "language": "Portuguese", "languageCode": "pt", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "GW" },
    { "name": "Guyana", "language": "English", "languageCode": "en", "currency": "GYD", "currencyName": "Guyanese Dollar", "code": "GY" },
    { "name": "Haiti", "language": "French", "languageCode": "fr", "currency": "HTG", "currencyName": "Haitian Gourde", "code": "HT" },
    { "name": "Honduras", "language": "Spanish", "languageCode": "es", "currency": "HNL", "currencyName": "Honduran Lempira", "code": "HN" },
    { "name": "Hungary", "language": "Hungarian", "languageCode": "hu", "currency": "HUF", "currencyName": "Hungarian Forint", "code": "HU" },
    { "name": "Iceland", "language": "Icelandic", "languageCode": "is", "currency": "ISK", "currencyName": "Icelandic Króna", "code": "IS" },
    { "name": "India", "language": "Hindi", "languageCode": "hi", "currency": "INR", "currencyName": "Indian Rupee", "code": "IN" },
    { "name": "Indonesia", "language": "Indonesian", "languageCode": "id", "currency": "IDR", "currencyName": "Indonesian Rupiah", "code": "ID" },
    { "name": "Iran", "language": "Persian", "languageCode": "fa", "currency": "IRR", "currencyName": "Iranian Rial", "code": "IR" },
    { "name": "Iraq", "language": "Arabic", "languageCode": "ar", "currency": "IQD", "currencyName": "Iraqi Dinar", "code": "IQ" },
    { "name": "Ireland", "language": "Irish", "languageCode": "ga", "currency": "EUR", "currencyName": "Euro", "code": "IE" },
    { "name": "Israel", "language": "Hebrew", "languageCode": "he", "currency": "ILS", "currencyName": "Israeli New Shekel", "code": "IL" },
    { "name": "Italy", "language": "Italian", "languageCode": "it", "currency": "EUR", "currencyName": "Euro", "code": "IT" },
    { "name": "Jamaica", "language": "English", "languageCode": "en", "currency": "JMD", "currencyName": "Jamaican Dollar", "code": "JM" },
    { "name": "Japan", "language": "Japanese", "languageCode": "ja", "currency": "JPY", "currencyName": "Japanese Yen", "code": "JP" },
    { "name": "Jordan", "language": "Arabic", "languageCode": "ar", "currency": "JOD", "currencyName": "Jordanian Dinar", "code": "JO" },
    { "name": "Kazakhstan", "language": "Kazakh", "languageCode": "kk", "currency": "KZT", "currencyName": "Kazakhstani Tenge", "code": "KZ" },
    { "name": "Kenya", "language": "Swahili", "languageCode": "sw", "currency": "KES", "currencyName": "Kenyan Shilling", "code": "KE" },
    { "name": "Kiribati", "language": "English", "languageCode": "en", "currency": "AUD", "currencyName": "Australian Dollar", "code": "KI" },
    { "name": "Korea, North", "language": "Korean", "languageCode": "ko", "currency": "KPW", "currencyName": "North Korean Won", "code": "KP" },
    { "name": "Korea, South", "language": "Korean", "languageCode": "ko", "currency": "KRW", "currencyName": "South Korean Won", "code": "KR" },
    { "name": "Kosovo", "language": "Albanian", "languageCode": "sq", "currency": "EUR", "currencyName": "Euro", "code": "XK" },
    { "name": "Kuwait", "language": "Arabic", "languageCode": "ar", "currency": "KWD", "currencyName": "Kuwaiti Dinar", "code": "KW" },
    { "name": "Kyrgyzstan", "language": "Kyrgyz", "languageCode": "ky", "currency": "KGS", "currencyName": "Kyrgyzstani Som", "code": "KG" },
    { "name": "Laos", "language": "Lao", "languageCode": "lo", "currency": "LAK", "currencyName": "Lao Kip", "code": "LA" },
    { "name": "Latvia", "language": "Latvian", "languageCode": "lv", "currency": "EUR", "currencyName": "Euro", "code": "LV" },
    { "name": "Lebanon", "language": "Arabic", "languageCode": "ar", "currency": "LBP", "currencyName": "Lebanese Pound", "code": "LB" },
    { "name": "Lesotho", "language": "Sotho", "languageCode": "st", "currency": "LSL", "currencyName": "Lesotho Loti", "code": "LS" },
    { "name": "Liberia", "language": "English", "languageCode": "en", "currency": "LRD", "currencyName": "Liberian Dollar", "code": "LR" },
    { "name": "Libya", "language": "Arabic", "languageCode": "ar", "currency": "LYD", "currencyName": "Libyan Dinar", "code": "LY" },
    { "name": "Liechtenstein", "language": "German", "languageCode": "de", "currency": "CHF", "currencyName": "Swiss Franc", "code": "LI" },
    { "name": "Lithuania", "language": "Lithuanian", "languageCode": "lt", "currency": "EUR", "currencyName": "Euro", "code": "LT" },
    { "name": "Luxembourg", "language": "Luxembourgish", "languageCode": "lb", "currency": "EUR", "currencyName": "Euro", "code": "LU" },
    { "name": "Madagascar", "language": "Malagasy", "languageCode": "mg", "currency": "MGA", "currencyName": "Malagasy Ariary", "code": "MG" },
    { "name": "Malawi", "language": "English", "languageCode": "en", "currency": "MWK", "currencyName": "Malawian Kwacha", "code": "MW" },
    { "name": "Malaysia", "language": "Malay", "languageCode": "ms", "currency": "MYR", "currencyName": "Malaysian Ringgit", "code": "MY" },
    { "name": "Maldives", "language": "Dhivehi", "languageCode": "dv", "currency": "MVR", "currencyName": "Maldivian Rufiyaa", "code": "MV" },
    { "name": "Mali", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "ML" },
    { "name": "Malta", "language": "Maltese", "languageCode": "mt", "currency": "EUR", "currencyName": "Euro", "code": "MT" },
    { "name": "Marshall Islands", "language": "English", "languageCode": "en", "currency": "USD", "currencyName": "United States Dollar", "code": "MH" },
    { "name": "Mauritania", "language": "Arabic", "languageCode": "ar", "currency": "MRU", "currencyName": "Mauritanian Ouguiya", "code": "MR" },
    { "name": "Mauritius", "language": "English", "languageCode": "en", "currency": "MUR", "currencyName": "Mauritian Rupee", "code": "MU" },
    { "name": "Mexico", "language": "Spanish", "languageCode": "es", "currency": "MXN", "currencyName": "Mexican Peso", "code": "MX" },
    { "name": "Micronesia", "language": "English", "languageCode": "en", "currency": "USD", "currencyName": "United States Dollar", "code": "FM" },
    { "name": "Moldova", "language": "Romanian", "languageCode": "ro", "currency": "MDL", "currencyName": "Moldovan Leu", "code": "MD" },
    { "name": "Monaco", "language": "French", "languageCode": "fr", "currency": "EUR", "currencyName": "Euro", "code": "MC" },
    { "name": "Mongolia", "language": "Mongolian", "languageCode": "mn", "currency": "MNT", "currencyName": "Mongolian Tögrög", "code": "MN" },
    { "name": "Montenegro", "language": "Montenegrin", "languageCode": "sr", "currency": "EUR", "currencyName": "Euro", "code": "ME" },
    { "name": "Morocco", "language": "Arabic", "languageCode": "ar", "currency": "MAD", "currencyName": "Moroccan Dirham", "code": "MA" },
    { "name": "Mozambique", "language": "Portuguese", "languageCode": "pt", "currency": "MZN", "currencyName": "Mozambican Metical", "code": "MZ" },
    { "name": "Myanmar (Burma)", "language": "Burmese", "languageCode": "my", "currency": "MMK", "currencyName": "Myanmar Kyat", "code": "MM" },
    { "name": "Namibia", "language": "English", "languageCode": "en", "currency": "NAD", "currencyName": "Namibian Dollar", "code": "NA" },
    { "name": "Nauru", "language": "English", "languageCode": "en", "currency": "AUD", "currencyName": "Australian Dollar", "code": "NR" },
    { "name": "Nepal", "language": "Nepali", "languageCode": "ne", "currency": "NPR", "currencyName": "Nepalese Rupee", "code": "NP" },
    { "name": "Netherlands", "language": "Dutch", "languageCode": "nl", "currency": "EUR", "currencyName": "Euro", "code": "NL" },
    { "name": "New Zealand", "language": "English", "languageCode": "en", "currency": "NZD", "currencyName": "New Zealand Dollar", "code": "NZ" },
    { "name": "Nicaragua", "language": "Spanish", "languageCode": "es", "currency": "NIO", "currencyName": "Nicaraguan Córdoba", "code": "NI" },
    { "name": "Niger", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "NE" },
    { "name": "Nigeria", "language": "English", "languageCode": "en", "currency": "NGN", "currencyName": "Nigerian Naira", "code": "NG" },
    { "name": "North Macedonia", "language": "Macedonian", "languageCode": "mk", "currency": "MKD", "currencyName": "Macedonian Denar", "code": "MK" },
    { "name": "Norway", "language": "Norwegian", "languageCode": "no", "currency": "NOK", "currencyName": "Norwegian Krone", "code": "NO" },
    { "name": "Oman", "language": "Arabic", "languageCode": "ar", "currency": "OMR", "currencyName": "Omani Rial", "code": "OM" },
    { "name": "Pakistan", "language": "Urdu", "languageCode": "ur", "currency": "PKR", "currencyName": "Pakistani Rupee", "code": "PK" },
    { "name": "Palau", "language": "English", "languageCode": "en", "currency": "USD", "currencyName": "United States Dollar", "code": "PW" },
    { "name": "Panama", "language": "Spanish", "languageCode": "es", "currency": "USD", "currencyName": "United States Dollar", "code": "PA" },
    { "name": "Papua New Guinea", "language": "English", "languageCode": "en", "currency": "PGK", "currencyName": "Papua New Guinean Kina", "code": "PG" },
    { "name": "Paraguay", "language": "Spanish", "languageCode": "es", "currency": "PYG", "currencyName": "Paraguayan Guaraní", "code": "PY" },
    { "name": "Peru", "language": "Spanish", "languageCode": "es", "currency": "PEN", "currencyName": "Peruvian Sol", "code": "PE" },
    { "name": "Philippines", "language": "Filipino", "languageCode": "tl", "currency": "PHP", "currencyName": "Philippine Peso", "code": "PH" },
    { "name": "Poland", "language": "Polish", "languageCode": "pl", "currency": "PLN", "currencyName": "Polish Złoty", "code": "PL" },
    { "name": "Portugal", "language": "Portuguese", "languageCode": "pt", "currency": "EUR", "currencyName": "Euro", "code": "PT" },
    { "name": "Qatar", "language": "Arabic", "languageCode": "ar", "currency": "QAR", "currencyName": "Qatari Riyal", "code": "QA" },
    { "name": "Romania", "language": "Romanian", "languageCode": "ro", "currency": "RON", "currencyName": "Romanian Leu", "code": "RO" },
    { "name": "Russia", "language": "Russian", "languageCode": "ru", "currency": "RUB", "currencyName": "Russian Ruble", "code": "RU" },
    { "name": "Rwanda", "language": "Kinyarwanda", "languageCode": "rw", "currency": "RWF", "currencyName": "Rwandan Franc", "code": "RW" },
    { "name": "Saint Kitts and Nevis", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "KN" },
    { "name": "Saint Lucia", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "LC" },
    { "name": "Saint Vincent and the Grenadines", "language": "English", "languageCode": "en", "currency": "XCD", "currencyName": "East Caribbean Dollar", "code": "VC" },
    { "name": "Samoa", "language": "Samoan", "languageCode": "sm", "currency": "WST", "currencyName": "Samoan Tālā", "code": "WS" },
    { "name": "San Marino", "language": "Italian", "languageCode": "it", "currency": "EUR", "currencyName": "Euro", "code": "SM" },
    { "name": "Sao Tome and Principe", "language": "Portuguese", "languageCode": "pt", "currency": "STN", "currencyName": "São Tomé and Príncipe Dobra", "code": "ST" },
    { "name": "Saudi Arabia", "language": "Arabic", "languageCode": "ar", "currency": "SAR", "currencyName": "Saudi Riyal", "code": "SA" },
    { "name": "Senegal", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "SN" },
    { "name": "Serbia", "language": "Serbian", "languageCode": "sr", "currency": "RSD", "currencyName": "Serbian Dinar", "code": "RS" },
    { "name": "Seychelles", "language": "French", "languageCode": "fr", "currency": "SCR", "currencyName": "Seychellois Rupee", "code": "SC" },
    { "name": "Sierra Leone", "language": "English", "languageCode": "en", "currency": "SLL", "currencyName": "Sierra Leonean Leone", "code": "SL" },
    { "name": "Singapore", "language": "English", "languageCode": "en", "currency": "SGD", "currencyName": "Singapore Dollar", "code": "SG" },
    { "name": "Slovakia", "language": "Slovak", "languageCode": "sk", "currency": "EUR", "currencyName": "Euro", "code": "SK" },
    { "name": "Slovenia", "language": "Slovene", "languageCode": "sl", "currency": "EUR", "currencyName": "Euro", "code": "SI" },
    { "name": "Solomon Islands", "language": "English", "languageCode": "en", "currency": "SBD", "currencyName": "Solomon Islands Dollar", "code": "SB" },
    { "name": "Somalia", "language": "Somali", "languageCode": "so", "currency": "SOS", "currencyName": "Somali Shilling", "code": "SO" },
    { "name": "South Africa", "language": "Zulu", "languageCode": "zu", "currency": "ZAR", "currencyName": "South African Rand", "code": "ZA" },
    { "name": "South Sudan", "language": "English", "languageCode": "en", "currency": "SSP", "currencyName": "South Sudanese Pound", "code": "SS" },
    { "name": "Spain", "language": "Spanish", "languageCode": "es", "currency": "EUR", "currencyName": "Euro", "code": "ES" },
    { "name": "Sri Lanka", "language": "Sinhala", "languageCode": "si", "currency": "LKR", "currencyName": "Sri Lankan Rupee", "code": "LK" },
    { "name": "Sudan", "language": "Arabic", "languageCode": "ar", "currency": "SDG", "currencyName": "Sudanese Pound", "code": "SD" },
    { "name": "Suriname", "language": "Dutch", "languageCode": "nl", "currency": "SRD", "currencyName": "Surinamese Dollar", "code": "SR" },
    { "name": "Sweden", "language": "Swedish", "languageCode": "sv", "currency": "SEK", "currencyName": "Swedish Krona", "code": "SE" },
    { "name": "Switzerland", "language": "German", "languageCode": "de", "currency": "CHF", "currencyName": "Swiss Franc", "code": "CH" },
    { "name": "Syria", "language": "Arabic", "languageCode": "ar", "currency": "SYP", "currencyName": "Syrian Pound", "code": "SY" },
    { "name": "Taiwan", "language": "Mandarin", "languageCode": "zh", "currency": "TWD", "currencyName": "New Taiwan Dollar", "code": "TW" },
    { "name": "Tajikistan", "language": "Tajik", "languageCode": "tg", "currency": "TJS", "currencyName": "Tajikistani Somoni", "code": "TJ" },
    { "name": "Tanzania", "language": "Swahili", "languageCode": "sw", "currency": "TZS", "currencyName": "Tanzanian Shilling", "code": "TZ" },
    { "name": "Thailand", "language": "Thai", "languageCode": "th", "currency": "THB", "currencyName": "Thai Baht", "code": "TH" },
    { "name": "Togo", "language": "French", "languageCode": "fr", "currency": "XOF", "currencyName": "West African CFA Franc", "code": "TG" },
    { "name": "Tonga", "language": "English", "languageCode": "en", "currency": "TOP", "currencyName": "Tongan Paʻanga", "code": "TO" },
  ]
  countryCodes: any = {
    afghanistan: 'AF',
    albania: 'AL',
    algeria: 'DZ',
    andorra: 'AD',
    angola: 'AO',
    antigua_and_barbuda: 'AG',
    argentina: 'AR',
    armenia: 'AM',
    australia: 'AU',
    austria: 'AT',
    azerbaijan: 'AZ',
    bahamas: 'BS',
    bahrain: 'BH',
    bangladesh: 'BD',
    barbados: 'BB',
    belarus: 'BY',
    belgium: 'BE',
    belize: 'BZ',
    benin: 'BJ',
    bhutan: 'BT',
    bolivia: 'BO',
    bosnia_and_herzegovina: 'BA',
    botswana: 'BW',
    brazil: 'BR',
    brunei: 'BN',
    bulgaria: 'BG',
    burkina_faso: 'BF',
    burundi: 'BI',
    cabo_verde: 'CV',
    cambodia: 'KH',
    cameroon: 'CM',
    canada: 'CA',
    central_african_republic: 'CF',
    chad: 'TD',
    chile: 'CL',
    china: 'CN',
    colombia: 'CO',
    comoros: 'KM',
    congo: 'CG',
    costa_rica: 'CR',
    cote_divoire: 'CI',
    croatia: 'HR',
    cuba: 'CU',
    cyprus: 'CY',
    czech_republic: 'CZ',
    denmark: 'DK',
    djibouti: 'DJ',
    dominica: 'DM',
    dominican_republic: 'DO',
    ecuador: 'EC',
    egypt: 'EG',
    el_salvador: 'SV',
    equatorial_guinea: 'GQ',
    eritrea: 'ER',
    estonia: 'EE',
    eswatini: 'SZ',
    ethiopia: 'ET',
    fiji: 'FJ',
    finland: 'FI',
    france: 'FR',
    gabon: 'GA',
    gambia: 'GM',
    georgia: 'GE',
    germany: 'DE',
    ghana: 'GH',
    greece: 'GR',
    grenada: 'GD',
    guatemala: 'GT',
    guinea: 'GN',
    guinea_bissau: 'GW',
    guyana: 'GY',
    haiti: 'HT',
    honduras: 'HN',
    hungary: 'HU',
    iceland: 'IS',
    india: 'IN',
    indonesia: 'ID',
    iran: 'IR',
    iraq: 'IQ',
    ireland: 'IE',
    israel: 'IL',
    italy: 'IT',
    jamaica: 'JM',
    japan: 'JP',
    jordan: 'JO',
    kazakhstan: 'KZ',
    kenya: 'KE',
    kiribati: 'KI',
    kuwait: 'KW',
    kyrgyzstan: 'KG',
    laos: 'LA',
    latvia: 'LV',
    lebanon: 'LB',
    lesotho: 'LS',
    liberia: 'LR',
    libya: 'LY',
    liechtenstein: 'LI',
    lithuania: 'LT',
    luxembourg: 'LU',
    madagascar: 'MG',
    malawi: 'MW',
    malaysia: 'MY',
    maldives: 'MV',
    mali: 'ML',
    malta: 'MT',
    marshall_islands: 'MH',
    mauritania: 'MR',
    mauritius: 'MU',
    mexico: 'MX',
    micronesia: 'FM',
    moldova: 'MD',
    monaco: 'MC',
    mongolia: 'MN',
    montenegro: 'ME',
    morocco: 'MA',
    mozambique: 'MZ',
    myanmar: 'MM',
    namibia: 'NA',
    nauru: 'NR',
    nepal: 'NP',
    netherlands: 'NL',
    new_zealand: 'NZ',
    nicaragua: 'NI',
    niger: 'NE',
    nigeria: 'NG',
    north_korea: 'KP',
    north_macedonia: 'MK',
    norway: 'NO',
    oman: 'OM',
    pakistan: 'PK',
    palau: 'PW',
    palestine: 'PS',
    panama: 'PA',
    papua_new_guinea: 'PG',
    paraguay: 'PY',
    peru: 'PE',
    philippines: 'PH',
    poland: 'PL',
    portugal: 'PT',
    qatar: 'QA',
    romania: 'RO',
    russia: 'RU',
    rwanda: 'RW',
    saint_kitts_and_nevis: 'KN',
    saint_lucia: 'LC',
    saint_vincent_and_the_grenadines: 'VC',
    samoa: 'WS',
    san_marino: 'SM',
    sao_tome_and_principe: 'ST',
    saudi_arabia: 'SA',
    senegal: 'SN',
    serbia: 'RS',
    seychelles: 'SC',
    sierra_leone: 'SL',
    singapore: 'SG',
    slovakia: 'SK',
    slovenia: 'SI',
    solomon_islands: 'SB',
    somalia: 'SO',
    south_africa: 'ZA',
    south_korea: 'KR',
    south_sudan: 'SS',
    spain: 'ES',
    sri_lanka: 'LK',
    sudan: 'SD',
    suriname: 'SR',
    sweden: 'SE',
    switzerland: 'CH',
    syria: 'SY',
    taiwan: 'TW',
    tajikistan: 'TJ',
    tanzania: 'TZ',
    thailand: 'TH',
    timor_leste: 'TL',
    togo: 'TG',
    tonga: 'TO',
    trinidad_and_tobago: 'TT',
    tunisia: 'TN',
    turkey: 'TR',
    turkmenistan: 'TM',
    tuvalu: 'TV',
    uganda: 'UG',
    ukraine: 'UA',
    united_arab_emirates: 'AE',
    united_kingdom: 'GB',
    united_states: 'US',
    uruguay: 'UY',
    uzbekistan: 'UZ',
    vanuatu: 'VU',
    vatican_city: 'VA',
    venezuela: 'VE',
    vietnam: 'VN',
    yemen: 'YE',
    zambia: 'ZM',
    zimbabwe: 'ZW'
  };
  getCountries(): Observable<any> {
    return this.http.get(`${environment.apiUrl}countries?active=true`, { withCredentials: true })
  }
}

export interface ILangs {
  name: string,
  language: string,
  currency: string,
  code: string,
  currencyName: string;
  languageCode: string;
}

